export enum logLevels {
  INFO = 'INFO',
  WARN = 'WARN',
  ERROR = 'ERROR',
  BACKEND_500 = 'BACKEND_500'
}

export default logLevels
